import { addThousandSeparator } from '../components/ADDON_LEARN_MORE_DIALOG/money'
import { t } from '../plugins/i18n'
import { cloneDeep } from 'lodash';
import { showDialog } from '@/utils/export';
import { BADGE_ID_MAPPER } from './auto-expire-badge';
import { PLAN_TYPES } from '@/components/planConst';

export const zoomOneEduSchoolPlanDetailsItemsGetter = (payLoad) => {
  const { largeMeetingCallback, enableDisplayZoomWorkFlow, enableDisplayZoomDrive, recordingCapacity, enableDocsFeature, showCampusScheduler, enableDisplayZoomTasksWithoutAccountCheck, isEligibleAccount4CustomAvatarFeature } = payLoad
  return [
    // Meetings
    {
      title: t('common.plans.meeting.title'),
      desc: t('plans.basic_free.upgrade.item1'),
      order: 10
    },
    // participants
    {
      title: t('common.statistics.participants', [addThousandSeparator(300)]),
      desc: t('common.per_meeting_unit'),
      order: 20,
      tips: {
        show: !!largeMeetingCallback,
        label: t('common.participant_limit.increase_with_large_meetings'),
        iconClass: 'zm-icon-info-outline',
        callback: largeMeetingCallback,
        tooltip: t('plans.largeMeeting.intro_tip')
      }
    },
    // AI
    {
      title: t('plans.ai_companion.title'),
      iconPath: 'ai-companion2',
      order: 30
    },
    // whiteboard
    {
      title: t('common.plans.whiteboard.title'),
      desc: t('detail_dialog.meeting_feature.zoom_whiteboards.unlimited'),
      order: 40
    },
    // Team Chat
    {
      title: t('common.plans.team_chat.title'),
      order: 50
    },
    // Mail and Calendar
    {
      title: t('common.plans.mail_calendar.title'),
      order: 60
    },
    // CUSTOM_AVATAR
    {
      hide: !isEligibleAccount4CustomAvatarFeature,
      title: t('fbc.plan_details.custom_avatar.title'),
      desc: t('fbc.plan_details.custom_avatar.label_text'),
      tooltip: t('fbc.plan_details.custom_avatar.comparison_table_tips'),
      badgeId: BADGE_ID_MAPPER.CUSTOM_AVATAR,
      ariaLabel: 'Learn more about Custom Avatars',
      order: 65
    },
    // cmr
    {
      title: t('common.plans.cloud_storage.title'),
      desc: t('plans.bundle_credit.storage', [recordingCapacity]),
      order: 70
    },
    // scheduler
    {
      title: t('fbc.plan_details.biz_plus.scheduler'),
      order: 75,
      shouldHide: !showCampusScheduler,
    },
    // translation
    {
      title: t('plans.translation.title'),
      order: 80
    },
    // extras
    {
      title: t('common.plans.extras.title'),
      desc: t('common.plans.extras.desc'),
      order: 90
    },
    // docs
    {
      hide: !enableDocsFeature,
      title: t('fbc.plan_details.biz_plus.docs.docs'),
      desc: t('meetings.unlimited'),
      tooltip: t('fbc.plan_details.biz_plus.docs.comparison_table_tips'),
      ariaLabel: 'Learn more about Zoom Docs',
      order: 100
    },
    // tasks
    {
      hide: !enableDisplayZoomTasksWithoutAccountCheck,
      title: t('fbc.plan_details.biz_plus.tasks.tasks'),
      desc: t('fbc.plan_details.biz_plus.tasks.tasks_label_text'),
      tooltip: t('fbc.plan_details.biz_plus.tasks.comparison_table_tips'),
      badgeId: BADGE_ID_MAPPER.TASKS,
      ariaLabel: 'Learn more about Zoom Tasks',
      order: 110
    },
    // zoom workflow
    {
      hide: !enableDisplayZoomWorkFlow,
      title: t('billing.plan.feature.workflow.title'),
      tooltip: t('billing.plan.feature.workflow.tip'),
      featureList: [
        'billing.plan.feature.workflow.desc_ai',
        'billing.plan.feature.workflow.desc_doc'
      ],
      learnMore: {
        callback: async () => await showDialog(await import(/* webpackChunkName: "zoom_work_flow_automation_dialog" */ '@/components/ZOOM_WORK_FLOW_AUTOMATION_DIALOG'), { visible: true }),
      },
      badgeId: BADGE_ID_MAPPER.WORKFLOW_AUTOMATION,
      ariaLabel: 'Learn more about Zoom WorkFlow',
      order: 100
    },
    // zoom drive
    {
      hide: !enableDisplayZoomDrive,
      title: t('billing.plan.feature.drive.title'),
      tooltip: t('billing.plan.feature.drive.tip'),
      featureList: [
        'billing.plan.feature.drive.feature1',
        'billing.plan.feature.drive.feature2'
      ],
      learnMore: {
        callback: async () => await showDialog(await import(/* webpackChunkName: "PLAN_LEARN_MORE_DIALOG" */ '@/components/PLAN_LEARN_MORE_DIALOG'), { visible: true, planType: PLAN_TYPES.DRIVE }),
      },
      badgeId: BADGE_ID_MAPPER.DRIVE,
      ariaLabel: 'Learn more about Drive',
      order: 105
    }
  ].filter(item => item.shouldHide !== true)
}

export const zoomOneEduSchoolPlusPlanDetailsItemsGetter = (payLoad) => {
  const zoomOneEduSchoolPlanDetailsItems = cloneDeep(zoomOneEduSchoolPlanDetailsItemsGetter(payLoad))
  zoomOneEduSchoolPlanDetailsItems.push(
    // zoom phone
    {
      title: t('fbc.plan_details.biz_plus.phone'),
      desc: t('fbc.plan_details.biz_plus.unlimited_regional'),
      order: 65
    },
    // scheduler
    {
      title: t('fbc.plan_details.biz_plus.scheduler'),
      order: 75,
    },
    // workspace reservation
    {
      title: t('workspaceReservation'),
      desc: t('plans.zoom_scheduler.desc'),
      order: 77
    },

  )
  zoomOneEduSchoolPlanDetailsItems.sort((a,b) => a.order - b.order)
  return zoomOneEduSchoolPlanDetailsItems
}


export const ZOOM_ONE_EDU_PLAN_DETAIL_PAGE_ID = {
  SCHOOL: 'school',
  SCHOOL_PLUS: 'schoolPlus'
}

export const RECORDING_CAPACITY = {
  SCHOOL: '5',
  SCHOOL_PLUS: '10'
}

export const BILLING_CYCLE = {
  MONTHLY: 'monthly',
  ANNUAL: 'annual'
}
